var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Услуги самозанятых",
      "create-text": "Новая",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "WorkServiceAdd",
      "route-edit": "WorkServiceEdit",
      "route-view": "WorkServiceView",
      "route-path": "/work_services",
      "can-edit": _vm.canEditWorkServiceCatalogs()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-294a4cea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-294a4cea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkServices/WorkServices.vue
// module id = null
// module chunks = 